module.exports = __webpack_public_path__ + "static/media/details-14-image-2.f4a33235.jpg";